module.exports = __webpack_public_path__ + "static/media/31.8ff47d43.png";